import React, { useState } from 'react'
import { Box, Pagination, Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Base from '../Components/Base'
import BooksFilterBar from '../Components/BooksFilterBar'
import BooksGrid from '../Components/BooksGrid'
import BookFormDialog from '../Components/BookFormDialog'
import { useToRead } from '../hooks/useToRead'

function ToRead() {
  const {
    books,
    sortBy,
    setSortBy,
    order,
    setOrder,
    page,
    setPage,
    totalPages,
    search,
    setSearch,
    clearSearch,
    refresh,
    setRefresh,
    priorities,
    setPriorities,
  } = useToRead()

  const [openForm, setOpenForm] = useState(false)
  const [editBook, setEditBook] = useState(null)

  const handleAddBook = () => {
    setEditBook(null)
    setOpenForm(true)
  }

  const handleEditBook = (book) => {
    setEditBook(book)
    setOpenForm(true)
  }

  return (
    <Base>
      <BooksFilterBar
        title={'Mes livres à lire'}
        search={search}
        onSearchChange={setSearch}
        onSearchClear={clearSearch}
        sortBy={sortBy}
        onSortChange={setSortBy}
        order={order}
        onOrderChange={setOrder}
        filterValues={priorities}
        onFilterChange={setPriorities}
        filterIconType="fire"
      />

      <BooksGrid books={books} refresh={refresh} setRefresh={setRefresh} onEdit={handleEditBook} />

      <BookFormDialog 
        open={openForm} 
        onClose={() => setOpenForm(false)} 
        book={editBook} 
        type="toRead" 
        onSuccess={() => setRefresh(true)} 
      />

      {totalPages > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 3,
            mb: 2,
          }}
        >
          <Pagination
            count={Math.max(1, totalPages)}
            page={page + 1}
            onChange={(_, value) => setPage(value - 1)}
            color="primary"
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            size="small"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      <Fab
        color="primary"
        aria-label="ajouter un livre"
        onClick={handleAddBook}
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: 1000,
        }}
      >
        <AddIcon />
      </Fab>
    </Base>
  )
}

export default ToRead
